import { render, staticRenderFns } from "./PelatihanPostTest.vue?vue&type=template&id=c01351b0"
import script from "./PelatihanPostTest.vue?vue&type=script&lang=js"
export * from "./PelatihanPostTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports